import { resolveOsintPlatformLogoUrl } from './osint-platform-logo.util';
import {
  createSimpleIconDataUrl,
  getSimpleIconBrandColor,
  resolveSimpleIcon,
  resolveSimpleIconSlug,
} from './simple-icons-brand.util';

export interface PlatformIconVisual {
  iconBg: string;
  iconText?: string;
  iconTextColor?: string;
  iconTextSize?: number;
  iconPath?: string;
  iconFill?: string;
  iconStroke?: string;
  iconStrokeWidth?: number;
}

export const BRAND_ICON_VISUALS: Record<string, PlatformIconVisual> = {
  gmail: { iconBg: '#ea4335', iconText: 'GM', iconTextSize: 22 },
  google: { iconBg: '#ea4335', iconText: 'GM', iconTextSize: 22 },
  outlook: { iconBg: '#0a64d6', iconText: 'OL', iconTextSize: 22 },
  yahoo: { iconBg: '#6001d2', iconText: 'Y!', iconTextSize: 22 },
  microsoft: {
    iconBg: '#00a4ef',
    iconPath:
      'M22 22h24v24H22zM50 22h24v24H50zM22 50h24v24H22zM50 50h24v24H50z',
    iconFill: '#ffffff',
  },
  apple: { iconBg: '#111827', iconText: 'AP', iconTextSize: 22 },
  linkedin: { iconBg: '#0a66c2', iconText: 'in', iconTextSize: 28 },
  instagram: { iconBg: '#d62976', iconText: 'IG', iconTextSize: 24 },
  facebook: { iconBg: '#1877f2', iconText: 'f', iconTextSize: 40 },
  foursquare: { iconBg: '#f94877', iconText: '4SQ', iconTextSize: 19 },
  eyecon: {
    iconBg: '#7c4dff',
    iconPath:
      'M48 30c-16 0-29 11-36 18 7 7 20 18 36 18s29-11 36-18c-7-7-20-18-36-18zm0 10a8 8 0 1 1 0 16 8 8 0 0 1 0-16z',
    iconFill: '#ffffff',
    iconStroke: 'none',
    iconStrokeWidth: 0,
  },
  x: { iconBg: '#111827', iconText: 'X', iconTextColor: '#ffffff', iconTextSize: 36 },
  twitter: { iconBg: '#111827', iconText: 'X', iconTextColor: '#ffffff', iconTextSize: 36 },
  truecaller: { iconBg: '#1e88e5', iconText: 'TC', iconTextSize: 24 },
  callapp: { iconBg: '#4c6ef5', iconText: 'CA', iconTextSize: 22 },
  tataplay: { iconBg: '#0b6bcb', iconText: 'TP', iconTextSize: 22 },
  unacademy: { iconBg: '#08bd80', iconText: 'UA', iconTextSize: 22 },
  ajio: { iconBg: '#2d2d2d', iconText: 'AJ', iconTextSize: 24 },
  flipkart: { iconBg: '#2874f0', iconText: 'FK', iconTextSize: 22 },
  simplerme: { iconBg: '#0ea5e9', iconText: 'SM', iconTextSize: 22 },
  simpleme: { iconBg: '#0ea5e9', iconText: 'SM', iconTextSize: 22 },
  whatsapp: { iconBg: '#25d366', iconText: 'WA', iconTextColor: '#10351d', iconTextSize: 24 },
  telegram: { iconBg: '#2aabee', iconText: 'TG', iconTextSize: 24 },
  skype: { iconBg: '#00aff0', iconText: 'S', iconTextSize: 36 },
  snapchat: { iconBg: '#fffc00', iconText: 'SC', iconTextColor: '#1a1a1a', iconTextSize: 22 },
  github: { iconBg: '#24292f', iconText: 'GH', iconTextSize: 24 },
  gitlab: { iconBg: '#fc6d26', iconText: 'GL', iconTextSize: 24 },
  youtube: { iconBg: '#ff0033', iconText: 'YT', iconTextSize: 24 },
  tiktok: { iconBg: '#111111', iconText: 'TT', iconTextSize: 24 },
  quora: { iconBg: '#b92b27', iconText: 'Q', iconTextSize: 38 },
  medium: { iconBg: '#121212', iconText: 'M', iconTextSize: 34 },
  reddit: { iconBg: '#ff4500', iconText: 'R', iconTextSize: 34 },
  pinterest: { iconBg: '#e60023', iconText: 'P', iconTextSize: 34 },
  discord: { iconBg: '#5865f2', iconText: 'D', iconTextSize: 34 },
  dropbox: { iconBg: '#0061ff', iconText: 'DB', iconTextSize: 22 },
  canva: { iconBg: '#00c4cc', iconText: 'CA', iconTextSize: 22 },
  myfitnesspal: { iconBg: '#0056ff', iconText: 'MFP', iconTextSize: 18 },
  whoxy: { iconBg: '#6b5cff', iconText: 'WHO', iconTextSize: 18 },
  quillbot: { iconBg: '#059669', iconText: 'QB', iconTextSize: 22 },
  naukri: { iconBg: '#1e88e5', iconText: 'NK', iconTextSize: 22 },
  syncme: { iconBg: '#00a3e0', iconText: 'SM', iconTextSize: 22 },
  yango: { iconBg: '#ffcc00', iconText: 'YG', iconTextColor: '#1a1a1a', iconTextSize: 22 },
  advancecaller: { iconBg: '#2563eb', iconText: 'AC', iconTextSize: 22 },
  redorsearch: { iconBg: '#dc2626', iconText: 'RS', iconTextSize: 22 },
  redorsearchapp: { iconBg: '#dc2626', iconText: 'RS', iconTextSize: 22 },
  truecallerid: { iconBg: '#1e88e5', iconText: 'TC', iconTextSize: 24 },
  truecallapp: { iconBg: '#4c6ef5', iconText: 'CA', iconTextSize: 22 },
  maps: {
    iconBg: '#34a853',
    iconPath:
      'M48 18c-11 0-20 8-20 19 0 14 20 39 20 39s20-25 20-39c0-11-9-19-20-19zm0 27a8 8 0 1 1 0-16 8 8 0 0 1 0 16z',
    iconFill: 'none',
    iconStroke: '#ffffff',
    iconStrokeWidth: 3.5,
  },
  googlemaps: {
    iconBg: '#34a853',
    iconPath:
      'M48 18c-11 0-20 8-20 19 0 14 20 39 20 39s20-25 20-39c0-11-9-19-20-19zm0 27a8 8 0 1 1 0-16 8 8 0 0 1 0 16z',
    iconFill: 'none',
    iconStroke: '#ffffff',
    iconStrokeWidth: 3.5,
  },
  carrier: {
    iconBg: '#64748b',
    iconPath:
      'M28 62h8V46H28zm16 0h8V34h-8zm16 0h8V22h-8z',
    iconFill: '#ffffff',
    iconStroke: 'none',
    iconStrokeWidth: 0,
  },
  currentcarrier: {
    iconBg: '#64748b',
    iconPath:
      'M28 62h8V46H28zm16 0h8V34h-8zm16 0h8V22h-8z',
    iconFill: '#ffffff',
    iconStroke: 'none',
    iconStrokeWidth: 0,
  },
};

const DEFAULT_PLATFORM_ICON: PlatformIconVisual = {
  iconBg: '#64748b',
  iconText: 'SRC',
  iconTextSize: 22,
};

function escapeSvg(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function toSvgDataUrl(svg: string): string {
  if (typeof btoa !== 'undefined') {
    return `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svg)))}`;
  }
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}

export function normalizePlatformKey(platform: string | null | undefined): string {
  return String(platform || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '');
}

export function resolveBrandKeyFromPlatform(platform: string | null | undefined): string | null {
  const normalized = normalizePlatformKey(platform);
  if (!normalized) {
    return null;
  }

  if (BRAND_ICON_VISUALS[normalized]) {
    return normalized;
  }

  const simpleSlug = resolveSimpleIconSlug(platform);
  if (simpleSlug) {
    return simpleSlug;
  }

  const haystack = String(platform || '').toLowerCase();
  const orderedKeys = Object.keys(BRAND_ICON_VISUALS).sort((a, b) => b.length - a.length);
  for (const key of orderedKeys) {
    if (haystack.includes(key)) {
      return key;
    }
  }

  if (haystack.includes('gmail') || haystack.includes('googlemail')) return 'gmail';
  if (haystack.includes('google') && haystack.includes('map')) return 'maps';
  if (haystack.includes('truecaller')) return 'truecaller';
  if (haystack.includes('truecallapp')) return 'truecallapp';
  if (haystack.includes('callapp')) return 'callapp';
  if (haystack.includes('tata play') || haystack.includes('tataplay')) return 'tataplay';
  if (haystack.includes('unacademy')) return 'unacademy';
  if (haystack.includes('flipkart')) return 'flipkart';
  if (haystack.includes('ajio')) return 'ajio';
  if (haystack.includes('simplerme') || haystack.includes('simple me') || haystack.includes('simpleme')) {
    return 'simplerme';
  }
  if (haystack.includes('quillbot')) return 'quillbot';
  if (haystack.includes('naukri')) return 'naukri';
  if (haystack.includes('syncme') || haystack.includes('sync.me')) return 'syncme';
  if (haystack.includes('yango')) return 'yango';
  if (haystack.includes('advancecaller') || haystack.includes('advance caller')) return 'advancecaller';
  if (haystack.includes('redorsearch')) return 'redorsearch';

  return null;
}

function initialsFromPlatform(platform: string): string {
  const compact = normalizePlatformKey(platform);
  if (!compact) return 'SRC';
  if (compact.length <= 3) return compact.toUpperCase();
  return compact.slice(0, compact.length > 8 ? 3 : 2).toUpperCase();
}

function accentFromPlatform(platform: string): string {
  const compact = normalizePlatformKey(platform);
  let hash = 0;
  for (let i = 0; i < compact.length; i += 1) {
    hash = (hash * 31 + compact.charCodeAt(i)) | 0;
  }
  const palette = [
    '#6366f1',
    '#0ea5e9',
    '#14b8a6',
    '#8b5cf6',
    '#f59e0b',
    '#ef4444',
    '#22c55e',
    '#ec4899',
    '#06b6d4',
    '#64748b',
  ];
  return palette[Math.abs(hash) % palette.length];
}

export function resolvePlatformIconVisual(platform: string | null | undefined): PlatformIconVisual {
  const brandKey = resolveBrandKeyFromPlatform(platform);
  if (brandKey && BRAND_ICON_VISUALS[brandKey]) {
    return BRAND_ICON_VISUALS[brandKey];
  }
  const brandColor = getSimpleIconBrandColor(platform);
  if (brandColor) {
    return {
      iconBg: brandColor,
      iconText: (brandKey || initialsFromPlatform(String(platform))).slice(0, 3).toUpperCase(),
      iconTextSize: 22,
    };
  }
  const name = String(platform || '').trim();
  if (!name) return DEFAULT_PLATFORM_ICON;
  const iconText = initialsFromPlatform(name);
  return {
    iconBg: accentFromPlatform(name),
    iconText,
    iconTextSize: iconText.length >= 3 ? 20 : 26,
  };
}

/** `public/osint-logo` when a file exists, otherwise Simple Icons, otherwise a letter badge. */
export function createPlatformIconDataUrl(
  platform: string | null | undefined,
  iconOnly = true,
): string {
  const localLogo = resolveOsintPlatformLogoUrl(platform);
  if (localLogo) {
    return localLogo;
  }

  const simpleIcon = resolveSimpleIcon(platform);
  if (simpleIcon) {
    if (iconOnly) {
      return createSimpleIconDataUrl(platform, { useBrandColor: true }) || '';
    }
    const accent =
      getSimpleIconBrandColor(platform) ||
      BRAND_ICON_VISUALS[resolveBrandKeyFromPlatform(platform) || '']?.iconBg ||
      `#${simpleIcon.hex}`;
    const svg = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96">
        <rect x="13" y="13" width="70" height="70" rx="18" fill="${accent}"/>
        <g transform="translate(24 24) scale(2)">
          <path fill="#ffffff" d="${simpleIcon.path}"/>
        </g>
      </svg>
    `.trim();
    return toSvgDataUrl(svg);
  }

  const visual = resolvePlatformIconVisual(platform);
  const text = escapeSvg(visual.iconText || '?');
  const accent = visual.iconBg || '#22c55e';
  const hasFilledPath = Boolean(visual.iconPath && visual.iconFill && visual.iconFill !== 'none');
  const iconMarkup = visual.iconPath
    ? `
        <path
          d="${visual.iconPath}"
          fill="${
            iconOnly
              ? hasFilledPath
                ? accent
                : 'none'
              : visual.iconFill || 'none'
          }"
          stroke="${
            iconOnly
              ? hasFilledPath
                ? 'none'
                : accent
              : visual.iconStroke || '#ffffff'
          }"
          stroke-width="${
            iconOnly
              ? hasFilledPath
                ? 0
                : 5
              : visual.iconStrokeWidth || 2.5
          }"
          stroke-linecap="round"
          stroke-linejoin="round"
        />`
    : `
        <text x="48" y="58"
          text-anchor="middle"
          font-family="Inter, Arial, sans-serif"
          font-size="${iconOnly ? Math.max(visual.iconTextSize || 0, 34) : visual.iconTextSize || (text.length >= 3 ? 24 : 34)}"
          font-weight="800"
          fill="${iconOnly ? accent : visual.iconTextColor || '#ffffff'}">${text}</text>`;

  const svg = iconOnly
    ? `
        <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96">
          <g>${iconMarkup}</g>
        </svg>
      `.trim()
    : `
        <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96">
          <rect x="13" y="13" width="70" height="70" rx="18" fill="${visual.iconBg}"/>
          <g>${iconMarkup}</g>
        </svg>
      `.trim();

  return toSvgDataUrl(svg);
}

function liftDarkBrandColor(hex: string): string {
  const raw = String(hex || '').replace('#', '');
  if (raw.length !== 6) return '#64748b';
  const red = Number.parseInt(raw.slice(0, 2), 16);
  const green = Number.parseInt(raw.slice(2, 4), 16);
  const blue = Number.parseInt(raw.slice(4, 6), 16);
  const luminance = (0.2126 * red + 0.7152 * green + 0.0722 * blue) / 255;
  return luminance < 0.18 ? '#4b5563' : `#${raw}`;
}

export interface GraphPlatformIconSpec {
  accent: string;
  simplePath: string | null;
  visual: PlatformIconVisual;
  /** File in `public/osint-logo` when this platform has a local logo. */
  logoUrl: string | null;
}

/**
 * Folder logo first. Simple Icons when that folder has no file for the platform.
 * Letter badge only when Simple Icons has no match either.
 */
export function resolveGraphPlatformIconSpec(
  platform: string | null | undefined,
): GraphPlatformIconSpec {
  const localLogo = resolveOsintPlatformLogoUrl(platform);
  const normalized = normalizePlatformKey(platform);
  const exactVisual = normalized ? BRAND_ICON_VISUALS[normalized] : undefined;
  const visual = exactVisual || resolvePlatformIconVisual(platform);

  if (localLogo) {
    return {
      accent: liftDarkBrandColor(visual.iconBg || '#64748b'),
      simplePath: null,
      visual,
      logoUrl: localLogo,
    };
  }

  const simpleIcon = resolveSimpleIcon(platform);
  if (simpleIcon) {
    return {
      accent: liftDarkBrandColor(getSimpleIconBrandColor(platform) || `#${simpleIcon.hex}`),
      simplePath: simpleIcon.path,
      visual,
      logoUrl: null,
    };
  }

  return {
    accent: liftDarkBrandColor(visual.iconBg || '#64748b'),
    simplePath: null,
    visual,
    logoUrl: null,
  };
}

/**
 * Graph nodes always use the same rounded tile so brand logos and letter
 * badges share one bounding box.
 */
export function createGraphPlatformIconDataUrl(platform: string | null | undefined): string {
  const spec = resolveGraphPlatformIconSpec(platform);
  if (spec.logoUrl) {
    return spec.logoUrl;
  }

  let inner = '';

  if (spec.simplePath) {
    inner = `<g transform="translate(20 20) scale(2.333)"><path fill="#ffffff" d="${spec.simplePath}"/></g>`;
  } else if (spec.visual.iconPath) {
    const fill = spec.visual.iconFill && spec.visual.iconFill !== 'none' ? spec.visual.iconFill : 'none';
    const stroke = fill === 'none' ? spec.visual.iconStroke || '#ffffff' : 'none';
    inner = `<path d="${spec.visual.iconPath}" fill="${fill}" stroke="${stroke}" stroke-width="${spec.visual.iconStrokeWidth || 2.5}" stroke-linecap="round" stroke-linejoin="round"/>`;
  } else {
    const text = escapeSvg(spec.visual.iconText || '?');
    const fontSize = text.length >= 3 ? 26 : 34;
    const fill = spec.visual.iconTextColor || '#ffffff';
    inner = `<text x="48" y="58" text-anchor="middle" font-family="Inter, Arial, sans-serif" font-size="${fontSize}" font-weight="800" fill="${fill}">${text}</text>`;
  }

  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96">
      <rect x="4" y="4" width="88" height="88" rx="20" fill="${spec.accent}"/>
      ${inner}
    </svg>
  `.trim();
  return toSvgDataUrl(svg);
}
